import React, { Component } from 'react';
import { translate } from "react-i18next";
import {  Button,  Row, Col, Form } from 'react-bootstrap';


class UserAdminList extends Component {

    constructor(props) {
        super(props);
        this.onEventInputChange = this.onEventInputChange.bind(this);
    
        this.state = {
            message: '',
            email:'',
            id:'',
            user: null
        }
    }

    onEventInputChange(obj) {
        const { name: fieldName, value: fieldValue } = obj.target;
        const { event } = this.state;

        this.setState({
            ...event,
            [fieldName]: fieldValue
        });

    }

  


    render() {
        const { t } = this.props;
        return (<div>
            <Row className="mt-3 greyBg pt-3 pb-3">
                <Col lg={6} md={6}>
                    <Form.Control value={this.state.email}
                        name="email"
                        onChange={this.onEventInputChange}
                        placeholder={t("email")}
                    />
                </Col>
                <Col lg={4} md={4}>
                    <Form.Control value={this.state.id}
                        name="id"
                        onChange={this.onEventInputChange}
                        placeholder={t("id")}
                    />
                </Col>
                <Col lg={2} md={2}>
                <Button   onClick={() => this.props.search(this.state.email, this.state.id)} className="float-right mt-1 " size="sm"><span className={ "fa fa-search mr-2" } ></span></Button>
                </Col>
            </Row>
            <hr/>
           
           
        </div>)
    }


}
export default translate("translations")(UserAdminList);